import React from "react";
import "./AllCompanyCard.css";
import { ArrowRight } from "lucide-react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import greenland from "../../../assets/CompanyCardLogos/GreenlandCard.jpg";
import soft from "../../../assets/CompanyCardLogos/SoftCard.png";
import tracker from "../../../assets/CompanyCardLogos/TrackerCard.jpg";
import globalTravels from "../../../assets/CompanyCardLogos/GlobalTravelsCard.jpg";
import transport from "../../../assets/CompanyCardLogos/TranportCard.jpg";
import shikhon from "../../../assets/CompanyCardLogos/ShikonCard.jpg";
import digital from "../../../assets/CompanyCardLogos/DigitalCard.jpg";
import furniture from "../../../assets/CompanyCardLogos/FurnitureCard.jpg";
import motors from "../../../assets/CompanyCardLogos/MotorsCard.jpg";
import express from "../../../assets/CompanyCardLogos/ExpressCard.jpg";
import holiday from "../../../assets/CompanyCardLogos/HolidaysCard.jpg";
import bdiconic from "../../../assets/CompanyCardLogos/BdIconicKsaCard.jpg";
import hajj from "../../../assets/CompanyCardLogos/HajjCard.jpg";

import { useNavigate } from "react-router-dom";

const businessConcerns = [
  {
    id: "express",
    title: "Iconic Express",
    image: express,
    description:
      "Fast and dependable express services designed to connect businesses and customers with greater convenience and efficiency.",
  },
  {
    id: "greenland",
    title: "Iconic Greenland",
    image: greenland,
    description:
      "A diversified business concern focused on quality products, innovation, and creating sustainable value for customers.",
  },
  {
    id: "global-travels",
    title: "Iconic Global Travels",
    image: globalTravels,
    description:
      "Complete travel solutions including tour packages, visa assistance, ticketing, and personalized travel experiences.",
  },
  {
    id: "furniture",
    title: "Iconic Furniture",
    image: furniture,
    description:
      "Premium furniture solutions combining contemporary design, functionality, craftsmanship, and lasting comfort.",
  },
  {
    id: "motors",
    title: "Iconic Motors",
    image: motors,
    description:
      "Automotive solutions focused on quality vehicles, customer satisfaction, and a reliable driving experience.",
  },
  {
    id: "soft",
    title: "Iconic Soft",
    image: soft,
    description:
      "Innovative software and technology solutions designed to help businesses grow, transform, and operate more efficiently.",
  },
  {
    id: "digital",
    title: "Iconic Digital Solutions",
    image: digital,
    description:
      "Modern digital solutions, creative experiences, and scalable technologies built for businesses in a rapidly evolving digital world.",
  },
  {
    id: "transport",
    title: "Iconic Transport",
    image: transport,
    description:
      "Reliable transportation solutions focused on comfort, safety, efficiency, and seamless mobility.",
  },
  {
    id: "bdiconic",
    title: "BD Iconic Company",
    image: bdiconic,
    description:
      "Connecting Bangladesh and global markets through business, services, strategic opportunities, and meaningful partnerships.",
  },
  {
    id: "tracker",
    title: "Iconic Tracker",
    image: tracker,
    description:
      "Smart tracking and management solutions helping businesses monitor operations, assets, and activities efficiently.",
  },
  {
    id: "holidays",
    title: "Iconic Holidays",
    image: holiday,
    description:
      "A celebration and special-occasion platform bringing memorable experiences, events, and moments to life.",
  },
  {
    id: "shikhon",
    title: "Iconic Shikhon",
    image: shikhon,
    description:
      "A learning-focused initiative committed to creating accessible opportunities for education, skills, and personal development.",
  },
  {
    id: "hajj",
    title: "Iconic Hajj Group",
    image: hajj,
    description:
      "Trusted Hajj and Umrah services designed to make every spiritual journey comfortable, organized, and meaningful.",
  },
];

const AllCompanyCard = () => {
  const navigate = useNavigate();

  return (
    <section className="company-section">
      <div className="company-container">
        <div className="company-header">
          <h2
            style={{
              fontSize: "35px",
              fontWeight: "bold",
              color: "#bd06b3",
              textTransform: "uppercase",
              letterSpacing: "1px",
            }}
          >
            Business <span style={{ color: "#00bfff" }}>Concerns</span>
          </h2>
          <p className="company-header-description">
            Discover our diverse group of companies and the services they offer.
          </p>
        </div>

        <div className="company-slider-wrapper">
          <Swiper
            modules={[Navigation, Pagination, Autoplay]}
            spaceBetween={20}
            slidesPerView={4}
            navigation
            pagination={{ clickable: true }}
            autoplay={{ delay: 3500, disableOnInteraction: false }}
            loop
            breakpoints={{
              0: {
                slidesPerView: 1,
                spaceBetween: 15,
              },
              576: {
                slidesPerView: 2,
                spaceBetween: 16,
              },
              768: {
                slidesPerView: 3,
                spaceBetween: 18,
              },
              1200: {
                slidesPerView: 3,
                spaceBetween: 20,
              },
            }}
          >
            {businessConcerns.map((company, index) => (
              <SwiperSlide key={`${company.title}-${index}`}>
                <div
                  className="company-card"
                  role="link"
                  tabIndex={0}
                  onClick={() => navigate(`/company/${company.id}`)}
                  onKeyDown={(event) => {
                    if (event.key === "Enter" || event.key === " ") {
                      event.preventDefault();
                      navigate(`/company/${company.id}`);
                    }
                  }}
                >
                  {/* Image */}
                  <img
                    src={company.image}
                    alt={company.title}
                    className="company-image"
                  />

                  {/* Overlay */}
                  <div className="company-overlay" />

                  {/* Content */}
                  <div className="company-content">
                    <h3>{company.title}</h3>

                    {/* Only ONE line */}
                    <div className="company-line" />

                    {/* Hover Description */}
                    <div className="company-description">
                      <p>{company.description}</p>

                      <button
                        onClick={(event) => {
                          event.stopPropagation();
                          navigate(`/company/${company.id}`);
                        }}
                        className="company-learn-more"
                      >
                        Learn More
                        <ArrowRight size={16} />
                      </button>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
};

export default AllCompanyCard;
